import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

import HomePage from "./pages/HomePage";
import PublicMenu from "./pages/PublicMenu";
import Login from "./pages/Login";
import Register from "./pages/Register";
import MyOrders from "./pages/MyOrders";

import DashboardLayout from "./pages/dashboard/DashboardLayout";
import OrderBoard from "./pages/dashboard/OrderBoard";
import Tables from "./pages/dashboard/Tables";
import Veresiye from "./pages/dashboard/Veresiye";
import MenuAdmin from "./pages/dashboard/MenuAdmin";
import Stock from "./pages/dashboard/Stock";
import Finance from "./pages/dashboard/Finance";
import Customers from "./pages/dashboard/Customers";
import Logs from "./pages/dashboard/Logs";
import ChatInbox from "./pages/dashboard/ChatInbox";
import CafeSettings from "./pages/dashboard/CafeSettings";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0B0B0C]">
    <div className="w-14 h-14 border-2 border-[#D4AF37]/20 border-t-[#D4AF37] rounded-full animate-spin" />
  </div>
);

const Protected = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/giris" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/menu" element={<PublicMenu />} />
      <Route path="/menu/:slug" element={<PublicMenu />} />
      <Route path="/giris" element={<Login />} />
      <Route path="/kayit" element={<Register />} />
      <Route path="/siparislerim" element={<Protected roles={["customer"]}><MyOrders /></Protected>} />

      <Route path="/panel" element={<Protected roles={["owner", "waiter"]}><DashboardLayout /></Protected>}>
        <Route index element={<Navigate to="/panel/siparisler" replace />} />
        <Route path="siparisler" element={<OrderBoard />} />
        <Route path="masalar" element={<Tables />} />
        <Route path="veresiye" element={<Protected roles={["owner"]}><Veresiye /></Protected>} />
        <Route path="menu" element={<Protected roles={["owner"]}><MenuAdmin /></Protected>} />
        <Route path="stok" element={<Stock />} />
        <Route path="finans" element={<Protected roles={["owner"]}><Finance /></Protected>} />
        <Route path="musteriler" element={<Protected roles={["owner"]}><Customers /></Protected>} />
        <Route path="loglar" element={<Protected roles={["owner"]}><Logs /></Protected>} />
        <Route path="sohbet" element={<Protected roles={["owner"]}><ChatInbox /></Protected>} />
        <Route path="ayarlar" element={<Protected roles={["owner"]}><CafeSettings /></Protected>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="bottom-center" theme="dark" richColors duration={1800} mobileOffset={{ bottom: 90 }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
